import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  AfterViewInit,
  Component,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { CKEditor4, CKEditorComponent } from 'ckeditor4-angular';
import { Observable } from 'rxjs';
import { AppInitService } from 'src/app/digigov/services/app-init.service';
import { map } from 'rxjs/operators';
import { MessageDisplayService } from 'src/app/digigov/services/message-display/message-display.service';
import { ApproveDraftConfirmationComponent } from 'src/app/digigov/dg_core/approve-draft-confirmation/approve-draft-confirmation.component';
import { SaveDraftConfirmationComponent } from 'src/app/digigov/dg_core/save-draft-confirmation/save-draft-confirmation.component';
import { CaseView } from 'src/app/digigov/models/caseview.model';

export interface IReadOnlyDialogData {
  docName: string;
  attachId: string | number;
  showAttachmentSourceCode: boolean;
}

export interface IAttachmentSourceData {
  extendedVO?: any;
  customXidBean?: any;
  dbSchema?: any;
  mpgId: number;
  attachMpgId: number;
  attachId: number;
  docTitle: string;
  docVer: number;
  docFileName: string;
  docSize: string;
  docFileType: string;
  dmsRefId: string;
  chkUsrId: number;
  locId: number;
  crtDt: string;
  crtPost: number;
  lstUpdtPost: number;
  activeFlg: number;
  appliedByPostId: number;
  actId: number;
  docVersionVOs?: any;
  fileBytes: string;
  createdByEmployee: string;
  contentType: string;
  versionType: string;
  versionDescription?: any;
  archived: number;
  mountId: number;
  mountPoint?: any;
  dmsRefId1?: any;
  size: string;
  attachCompressMpgVO?: any;
  docTypeNameConvention: string;
  docTypeCode?: any;
  docTypeId?: any;
  encryptionFlag?: any;
  headerFileBytes: string;
  footerFileBytes: string;
  strContent: string;
  strFooter: string;
  strHeader: string;
}

@Component({
  selector: 'app-draft-dialog',
  templateUrl: './draft-dialog.component.html',
  styleUrls: ['./draft-dialog.component.scss'],
})
export class DraftDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('stepper') stepper: MatStepper;
  selectedIndex: any = 0;
  formGen: FormGroup;
  createDraft: FormGroup;
  isCompleted = false;
  formCheck = true;
  enableStep2 = true;
  componentInputs;
  componentOutputs = ['appGenDataEmit'];
  private isFullScreen = false;
  isDraftChanged = false;
  isEditorLoaded = false;
  draftForm: FormGroup;
  maxChars = 300;

  //Create Draft Var
  draftTitle: any;
  draftId: number;
  mpgId: number;
  lineHeightList = '1;1.25;1.5;2;2.25;2.75;3;4';
  public editorConfig: any = {
    height: '650px',
    width: '100%',
    removePlugins: 'scayt',
    disableNativeSpellChecker: false,
    removeButtons:
      'ImageButton,Image,About,Paste,PasteFromWord,PasteAsPlainText',
    uiColor: '#7964b1',
    allowedContent: true,
    delayIfDetached: true,
    line_height: this.lineHeightList,
    extraPlugins: ['base64image', 'lineheight', 'pastebase64', 'dg-clip'],
    contentsCss: ['/assets/custom-ckeditor.css'],
    extraAllowedContent: '*{*}',
    pasteFilter: null,
    on: {
      dgClip: (evnt) => {
        this.addClip(evnt);
      },
    },
    /* scayt_sLang: 'en_GB',
    scayt_autoStartup: true, */
  };
  from: string;
  draftBase64: string;
  caseDetails: CaseView;
  draftMpgDtls: any;
  selectedDraft: any;
  showAttachmentFlag = false;
  currentType = 'pdf';
  previewSrc = null;
  onlyPreview = false;
  data = new FormControl('');
  content: any;
  tmpltId: any;
  title: any;
  placeHolderMap: any;
  readOnlyCkeditor = false;
  showSubmit = true;
  postData: any = {
    tmpltId: null,
    placeHolderMap: null,
  };
  isHeader = true;
  isContent = true;
  isFooter = true;
  headerData = null;
  contentData = '';
  footerData = null;
  contentTemplate;
  headerTemplate;
  footerTemplate;
  categoryId;
  showTemplateSelection = false;
  fullsection: any = true;
  plmap = {};
  isDraftApproved = false;
  attachId = -1;
  //Create Draft Var
  placeholderMapFromAppGen = {};
  formId = null;
  fromSaveAndPublish = false;
  showSaveAndPublishBtn = true;
  showSaveAndCloseBtn = true;
  showSaveBtn = true;
  showApproveBtn = true;
  showPreviewBtn = true;
  beforeApproveDrftMpgId = -1;
  showCkEditor: boolean = false;

  @ViewChild('editor') editor: CKEditorComponent;
  height = '100%';
  pageRendered = false;
  showEditor = true;
  ckInitialized = false;
  ckEditorUrl = '/assets/ckeditor/ckeditor.js';
  attachmentSourceData = '';
  attachmentDocName = '';
  readOnlyEditorConfig: any = {
    height: '650px',
    width: '100%',
    toolbar: [['select-all-copy']],
    allowedContent: true,
    delayIfDetached: true,
    line_height: this.lineHeightList,
    extraAllowedContent: '*{*}',
    pasteFilter: null,
    contentsCss: ['/assets/custom-ckeditor.css'],
  };
  draftAppgenFormGroup = new FormGroup({
    isValid: new FormControl(false, [Validators.required]),
  });
  docTypeCode: any;
  isApprover = false;
  letterNo: any;
  fileBytes: string = '';
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private http: HttpClient,
    private sanitize: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public dialogData: IReadOnlyDialogData | any,
    public dialogRef: MatDialogRef<DraftDialogComponent>,
    public appInitService: AppInitService,
    private dialog: MatDialog,
    private messageDisplayService: MessageDisplayService
  ) {
    if (this.dialogData?.showAttachmentSourceCode) {
      this.getAttachmentSourceData();
    } else {
      this.setGlobel(dialogData);
      this.appInitService?.getConfigurableFields()?.subscribe(() => {
        this.showSaveAndPublishBtn = this.appInitService?.appConfig?.configurableFields?.showSaveAndPublishBtnInDraftDialog;
        this.showSaveAndCloseBtn = this.appInitService?.appConfig?.configurableFields?.showSaveAndCloseBtnInDraftDialog;
        this.showSaveBtn = this.appInitService?.appConfig?.configurableFields?.showSaveBtnInDraftDialog;
        this.showApproveBtn = this.appInitService?.appConfig?.configurableFields?.showApproveBtnInDraftDialog;
      });
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.pageRendered && !this.dialogData?.showAttachmentSourceCode) {
      this.setEditorPreviewHeight();
    }
  }
  ngAfterViewInit(): void {
    this.pageRendered = true;
    if (!this.dialogData?.showAttachmentSourceCode) {
      this.setEditorPreviewHeight();
    }
  }
  setEditorPreviewHeight(): void {
    if (this.pageRendered) {
      let myDiv = document.getElementById('draft-main');
      let height = myDiv.clientHeight - 280;
      if (this.formId && this?.caseDetails?.appTypeId) {
        height = height - 60;
        this.height = myDiv.clientHeight - 150 + 'px';
      }

      if (this.editor && false) {
        this.showEditor = false;
        this.editor.config.height = height + 'px';
        setTimeout(() => {
          this.showEditor = true;
        });
      }
    }
  }
  setGlobel(dialogData) {
    this.from = dialogData?.from;
    this.selectedDraft = dialogData?.selectedDraft;
    this.caseDetails = dialogData?.case;
    this.draftMpgDtls = dialogData?.draftMpgDtls;
    this.content = dialogData?.content;
    this.tmpltId = dialogData?.tmpltId;
    this.placeHolderMap = dialogData?.placeHolderMap;
    this.title = dialogData?.title;
    this.showSubmit = dialogData?.showSubmit ? dialogData?.showSubmit : true;
    this.readOnlyCkeditor = dialogData?.readonly ? dialogData?.readonly : false;
  }

  draftVersion(): void {
    const dataForPost = {
      draftId: this.dialogData?.selectedDraft?.draftId,
      mpgId: this.dialogData?.selectedDraft?.mpgId,
      mvmntPk: this.caseDetails?.jobMvmntPk,
    };
    this.http
      .post('/case-mgmnt/draft-data-from-mpgId', dataForPost)
      .subscribe((res: any) => {
        this.contentData = atob(res?.data?.fileBytes);
        this.contentTemplate = atob(res?.data?.fileBytes);
        this.data.setValue(res?.data?.strContent);

        if (res?.data?.docFileType === 'pdf') {
          this.getApprovedDraftView();
        }
      });
  }

  outputFromAppGen(event) {
    let placeholderMapFromAppGen = Object.keys(
      event[0]?.data?.placeholderMap
    ).reduce((map, item) => {
      let value = event[0]?.data?.placeholderMap?.[item];
      let key = item?.split('.')?.[1];
      map[key] = value;
      return map;
    }, {});
    this.plmap = event[0]?.data?.plmap;
    this.placeholderMapFromAppGen = placeholderMapFromAppGen;
    this.draftAppgenFormGroup.controls['isValid'].setValue(
      event?.[0]?.data?.isValid ? event?.[0]?.data?.isValid : null
    );
  }

  getviewData(versionFlag): void {
    let draft_Id = this.selectedDraft.draftId;
    let params = new HttpParams();
    params = params.append('draftId', draft_Id);
    params = params.append('isListFlag', true);
    params = params.append('versionFlag', versionFlag);
    params = params.append(
      'mvmntPk',
      this.caseDetails.jobMvmntPk ? this.caseDetails.jobMvmntPk : -1
    );
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    this.http
      .get('/case-mgmnt/preview-draft', { headers: headers, params: params })
      .subscribe((res: any) => {
        this.fileBytes = res?.data?.fileBytes;
        this.contentData = atob(res?.data?.fileBytes);
        this.headerData = atob(res?.data?.headerFileBytes);
        this.footerData = atob(res?.data?.footerFileBytes);
        this.contentTemplate = atob(res?.data?.fileBytes);
        this.data.setValue(res?.data?.strContent);
        this.headerTemplate = res?.data?.strHeader;
        this.footerTemplate = res?.data?.strFooter;
        this.draftTitle = this?.dialogData?.title;
        this.attachId = res?.data?.attachId;
        this.mpgId = res?.data?.mpgId;
        this.docTypeCode = res?.data?.docTypeCode;
        this.setEditorPreviewHeight();
      });
  }

  prepareDraft(caseDetails, templateId): void {
    let plMapDialog = this.dialogData?.plMapForLetter
      ? this.dialogData?.plMapForLetter
      : null;
    let paramMapDialog = this.dialogData?.paramForLetter
      ? this.dialogData?.paramForLetter
      : null;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let dataForPost: any = {
      draftMpgId: templateId.optionValue,
      refId: caseDetails.docId,
      appId: caseDetails.appTypeId,
      subjectId: caseDetails.subjectId,
      jobId: caseDetails.jobId,
      draftTitle: templateId.optionText,
      plmap: { ...this.dialogData.plmap, ...this.plmap },
      placeHolderMap: {
        ...this.dialogData?.placeHolderMap,
        ...this.placeholderMapFromAppGen,
      },
    };
    if (plMapDialog) {
      dataForPost.plmap = { ...dataForPost?.plmap, ...plMapDialog };
    }
    if (paramMapDialog) {
      dataForPost.placeHolderMap = {
        ...dataForPost?.placeHolderMap,
        ...paramMapDialog,
      };
    }
    if (this.dialogData?.additionalDtls) {
      dataForPost = {
        ...this.dialogData?.additionalDtls,
        ...dataForPost,
      };
    }
    if (dataForPost?.cases?.length) {
      dataForPost.cases = dataForPost?.cases.map((c: any) => {
        delete c.componentAddress;
        delete c?.componentInputs;
        delete c?.componentOutputIds;
        delete c?.componentOutputs;
        delete c?.output;
        return c;
      });
    }

    delete dataForPost?.data?.componentAddress;
    delete dataForPost?.data?.componentInputs;
    delete dataForPost?.data?.componentOutputIds;
    delete dataForPost?.data?.componentOutputs;
    delete dataForPost?.data?.output;

    delete dataForPost?.componentAddress;
    delete dataForPost?.componentInputs;
    delete dataForPost?.componentOutputIds;
    delete dataForPost?.componentOutputs;
    delete dataForPost?.output;

    dataForPost.plmap = this.removeSpecialChars(dataForPost?.plmap);

    this.http
      .post('/case-mgmnt/prepare-draft', dataForPost, {
        headers: headers,
      })
      .subscribe(
        (res: any) => {
          this.setPreviewDraftData(res);
          this.setEditorPreviewHeight();
        },
        (err) => {
          console.log(err);
        }
      );
  }
  removeSpecialChars(map): any {
    if (map && map != null && typeof map == 'object') {
      Object.keys(map)?.forEach((ele) => {
        if (typeof map[ele] == 'object') {
          map[ele] = this.removeSpecialChars(map[ele]);
        } else {
          map[ele] = map[ele]?.toString()?.trim()?.replaceAll('“', '"');
          map[ele] = map[ele]?.toString()?.trim()?.replaceAll('”', '"');
          map[ele] = map[ele]?.toString()?.trim()?.replaceAll('‘', "'");
          map[ele] = map[ele]?.toString()?.trim()?.replaceAll('–', '-');
          map[ele] = map[ele]?.toString()?.trim()?.replaceAll('’', "'");
        }
      });
    }
    return map;
  }
  //ADDED THIS FUNC TO SHOW ATTACHMENT SOURCE
  getAttachmentSourceData(): void {
    this.attachmentDocName = this.dialogData?.docName;
    this.http
      .get(
        `/case-mgmnt/draft-dtls-by-attachId?attachId=${this.dialogData.attachId}`
      )
      .pipe(map((res: any) => res?.data))
      .subscribe((data: IAttachmentSourceData) => {
        this.attachmentSourceData = '';
        if (data?.docFileName) {
          this.attachmentDocName = data.docFileName;
        }
        if (data?.strHeader) {
          this.attachmentSourceData =
            this.attachmentSourceData + data?.strHeader;
        }
        if (data?.strContent) {
          this.attachmentSourceData =
            this.attachmentSourceData + data?.strContent;
        }
        if (data?.strFooter) {
          this.attachmentSourceData =
            this.attachmentSourceData + data?.strFooter;
        }
      });
  }

  ngOnInit(): void {
    this.http
      .post('/case-mgmnt/get-draft-approver-rights', {})
      .subscribe((res: any) => {
        this.isApprover = res.data;
      });
    this.data.valueChanges.subscribe(() => {
      if (!this.showCkEditor) {
        this.showCkEditor = true;
      }
    });
    this.draftForm = new FormGroup({
      draftTitle: new FormControl(null, [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(300),
      ]),
      officeEnabled: new FormControl(false, []),
    });
    document.body.style.position = 'relative';
    if (!this.dialogData?.showAttachmentSourceCode) {
      this.http
        .post('/admin/is-checklist', {
          tmpltId: this.draftMpgDtls?.tmpltId,
          docTypeCode: this.dialogData?.docTypeCode
            ? this.dialogData?.docTypeCode
            : this.dialogData?.titleDesc,
          mpgId: this.dialogData?.mpgId,
        })
        ?.subscribe((res: any) => {
          if (res?.data != -1) {
            this.formId = res?.data;
            this.componentInputs = {
              formId: this.formId,
              appId: this.dialogData?.appId, //this.appId,
              eventId: 1,
              data: this.dialogData?.data,
              parentEventData: this.dialogData?.parentEventData,
              caseVO: this.dialogData?.caseVO,
              cases: this.dialogData?.cases,
              menuFetchData: this.dialogData?.menuFetchData,
              emitAppGenData: true,
            };
            if (this.dialogData?.additionalDtls) {
              this.componentInputs = {
                ...this.componentInputs,
                ...this.dialogData?.additionalDtls,
              };
            }
          } else {
            if (!(this.formId && this.caseDetails?.appTypeId)) {
              this.onNext();
            }
          }
        });
    }
    if (this.dialogData?.readonly) {
      this.draftForm.get('draftTitle').disable();
    }
  }

  ngOnDestroy(): void {
    document.body.style.position = '';
  }

  onNext() {
    this.setEditorPreviewHeight();
    if (this.formId && this.caseDetails?.appTypeId) {
      this.stepper.next();
      // this.stepper.selectedIndex = 1;
      this.selectedIndex = 1;
    }
    this.getDraftData();
  }

  getDraftData(flag: any = -1): void {
    if (this.dialogData?.docTypeCode?.toString()?.length > 0) {
      this.getDocTypeConfigVOFromDocTypeCode(
        this.dialogData?.docTypeCode,
        this.dialogData?.actionId,
        this.caseDetails?.docId,
        this.dialogData?.newEventId
          ? Number(this.dialogData?.newEventId)
          : this.dialogData?.templateNotificationEventId
          ? Number(this.dialogData?.templateNotificationEventId)
          : -1,
        flag
      )?.subscribe((res) => {
        res = res.data;
        this.setDocDtls(res, flag);
      });
    } else if (this.dialogData?.selectedDraft?.draftId) {
      const params = new HttpParams()
        .set('fileId', this.caseDetails?.docId)
        .set('draftId', this.dialogData?.selectedDraft?.draftId)
        .set('appId', this.caseDetails?.appTypeId);

      this.http
        .get('/case-mgmnt/get-draft-data', {
          params: params,
        })
        .subscribe((res: any) => {
          let temp = res.data;
          this.draftId = temp?.draftId;
          this.selectedDraft.draftId = this.draftId;
          this.selectedDraft.draftStatus = temp?.draftStatus;
          // this.selectedDraft.draftMpgId = this.dialogData.draftId;
          this.selectedDraft.mpgId = this.selectedDraft.mpgId
            ? this.selectedDraft.mpgId
            : temp?.mpgId;
          this.from = this.draftId ? 'view' : 'prepare';
          this.draftTitle = temp?.draftTitle;
          this.dialogData.title = temp?.draftTitle;
          this.docTypeCode = temp?.docTypeCode;
          this.openDraft(flag);
        });
    } else {
      this.from = 'prepare';
      this.openDraft(flag);
    }
  }

  setDocDtls(res, flag): void {
    this.dialogData.from = res?.DRAFT_ID ? 'view' : 'prepare';
    this.dialogData.draftMpgDtls = {
      optionValue: res?.SUB_DRAFT_MPG_ID,
      optionText: res?.TEMPLATE_NAME,
    };
    this.dialogData.title = res?.TEMPLATE_NAME;
    this.dialogData.tmpltId = res?.templateId;
    this.dialogData.selectedDraft = res?.DRAFT_ID
      ? {
          draftId: res?.DRAFT_ID,
          draftStatus: res?.draftStatus,
          draftMpgId: res?.SUB_DRAFT_MPG_ID,
          mpgId: res?.mpgId,
          publishMode: null,
        }
      : {};
    this.setPublishMode(res);
    this.beforeApproveDrftMpgId = res?.beforeApprovempgId;
    this.setGlobel(this.dialogData);
    this.showDraft(flag);
  }

  setPublishMode(res): void {
    // if (res?.DRAFT_ID) {
    //   this.dialogData.selectedDraft.publishMode = this.setPublishModeFromPlMap();
    //   if (!this.dialogData?.selectedDraft?.publishMode) {
    //     this.dialogData.selectedDraft.publishMode = res?.publishMode;
    //   }
    // } else {
    //   this.dialogData.selectedDraft.publishMode = res?.publishMode;
    // }
    this.dialogData.selectedDraft.publishMode = this.setPublishModeFromPlMap();
    if (!this.dialogData?.selectedDraft?.publishMode) {
      this.dialogData.selectedDraft.publishMode = res?.publishMode;
    }
  }

  setPublishModeFromPlMap(): any {
    try {
      let a = this.dialogData?.plMapForLetter;
      a = JSON.stringify(a);
      if (a?.indexOf('isPublishMode') > -1) {
        a = a?.[a?.indexOf('isPublishMode') + 16];
        if (!Number.isNaN(Number(a))) {
          return Number(a);
        } else {
          return null;
        }
      } else {
        return null;
      }
    } catch (e) {
      console.error('Error in setPublishModeFromPlMap', e);
      return null;
    }
  }

  showDraft(versionFlag): void {
    if (!this.dialogData?.flag) {
      this.openDraft(versionFlag);
    } else {
      if (this.content?.length > 0) {
        this.data.setValue(this.dialogData.content);

        this.contentData = this.data.value;
      } else {
        this.postData.tmpltId = this.dialogData.tmpltId;
        this.postData.placeHolderMap = this.dialogData.placeHolderMap;

        this.http
          .post<any>('/admin/template-content', this.postData)
          .subscribe((res: any) => {
            this.data.setValue(res?.data);
            this.contentData = this.data.value;
          });
      }
    }
  }

  openDraft(versionFlag): void {
    if (this.from == 'prepare') {
      this.showAttachmentFlag = false;
      this.onlyPreview = false;
      if (versionFlag !== contentValue.createDraftWithCurrentContent) {
        this.prepareDraft(this.caseDetails, this.draftMpgDtls);
      }
    } else if (this.from == 'view') {
      if (this.selectedDraft) {
        if (
          this.dialogData?.selectedDraft?.draftStatus?.toString()?.trim() !==
            '969' &&
          versionFlag === -1
        ) {
          if (this.dialogData.readonly) {
            this.draftVersion();
          } else {
            this.showAttachmentFlag = true;
            this.onlyPreview = true;
            this.getApprovedDraftView();
            this.isDraftApproved = true;
            this.readOnlyCkeditor = true;
          }
        } else {
          if (this.dialogData.readonly) {
            this.draftVersion();
          } else {
            this.getviewData(versionFlag);
          }
          this.showAttachmentFlag = false;
          this.onlyPreview = false;
        }
      }
    } else {
      console.error('from undefined');
    }
  }

  onTitleChange() {
    this.isDraftChanged = true;
  }

  onEditorReady(editor: CKEditor4.Editor) {
    this.isEditorLoaded = true;
  }

  cancel() {
    if (
      this.showAttachmentFlag &&
      this.selectedDraft.draftStatus?.toString() === '969'
    ) {
      //ADDED CONDITION FOR PREV TO EDIT MODE
      this.openDraft(-1);
    } else {
      if (
        this.attachId > -1 &&
        this.selectedDraft.draftStatus?.toString() !== '969'
      ) {
        if (this.fromSaveAndPublish) {
          this.dialogRef.close({
            canProceed: true,
            attach: this.attachId,
            eventName: 'saveAndPublish',
            event: 0,
          });
        } else if (this.dialogData?.selectedDraft?.publishMode === 4) {
          this.dialogRef.close({
            canProceed: true,
            attach: this.attachId,
          });
        } else {
          this.dialogRef.close({
            canProceed: false,
            attach: this.attachId,
          });
        }
      } else {
        this.checkForDraftChanges();
      }
    }
  }

  checkForDraftChanges() {
    if (this.isDraftChanged) {
      const dialogRef = this.dialog.open(SaveDraftConfirmationComponent, {
        disableClose: true,
      });
      dialogRef.componentInstance.choice.subscribe((choice: boolean) => {
        if (choice == true) {
          this.save('save&close').subscribe();
          this.dialogRef.close({
            canProceed: false,
            attach: this.attachId,
          });
        } else {
          this.dialogRef.close({ canProceed: false, attach: this.attachId });
        }
      });
    } else {
      this.dialogRef.close({
        canProceed: false,
        attach: this.attachId,
      });
    }
  }

  onCreateDraft() {}

  onClickExp(event) {}

  saveAndPrintDraft(): void {
    let data = this.preapareSaveDraftVO();
    data = {
      ...data,
      docPublishType: this?.dialogData?.selectedDraft?.publishMode,
    };
    data = { ...data, notificationVO: this.prepareNotificationVO() };

    this.http.post('/case-mgmnt/save-and-print-draft', data).subscribe(
      (res: any) => {
        this.isDraftApproved = true;
        this.readOnlyCkeditor = true;
        this.from = 'view';
        this.selectedDraft.draftStatus = '970';
        this.selectedDraft.mpgId = res?.data?.mpgId;
        this.dialogData.selectedDraft = this.selectedDraft;
        this.fromSaveAndPublish = true;
        this.getDraftData();
      },
      (err) => {
        //
        console.log(err);
      }
    );
  }

  save(fromActon): Observable<any> {
    this.dialogData.title = this.draftForm.get('draftTitle').value;
    this.dialogData.officeEnabled = this.draftForm.get('officeEnabled').value
      ? this.draftForm.get('officeEnabled').value
      : false;
    // alert(this.dialogData.officeEnabled);
    this.isDraftChanged = false;
    let data = this.preapareSaveDraftVO();

    return this.http.post('/case-mgmnt/save-draft', data).pipe(
      map(
        (res: any) => {
          if (this.from == 'prepare') {
            this.selectedDraft.draftId = res?.data?.draftId;
            this.selectedDraft.mpgId = res?.data?.mpgId;
            this.draftId = res.data.draftId;
            //this.mpgId = res.data.mpgId;
            this.attachId = res?.data?.attachId;
            //this.letterNo = res?.data?.letterNo;
            this.from = 'view';
          }
          this.mpgId = res.data.mpgId; //TAKING MPGID FROM RESPONSE OF SAVE API FOR BOTH PREPARE AND VIEW MODE
          if (fromActon == 'save&close') {
            this.dialogRef.close('success');
          }
        },
        (err) => {
          console.log(err);
        }
      )
    );
  }

  preapareSaveDraftVO(): any {
    let data;
    let docTypeCode = '';
    if (this.dialogData?.docTypeCode) {
      docTypeCode = this.dialogData?.docTypeCode;
    } else if (this.dialogData?.draftTitleDesc) {
      docTypeCode = this.dialogData?.draftTitleDesc;
    } else {
      docTypeCode = null;
    }
    let letterNo = '';
    // this.letterNo = this.selectedDraft?.draftTitle
    //   .split('-')[1]
    //   .trim()
    //   .replace(/\D/g, '');
    if (this.from == 'prepare') {
      let draftMpgId = '';
      try {
        draftMpgId = this.draftMpgDtls?.optionValue?.split('~')[0];
      } catch (e) {
        draftMpgId = this.draftMpgDtls?.optionValue;
      }

      data = {
        draftId: this.draftId ? this.draftId : -1,
        refId: this.caseDetails.docId,
        appId: this.caseDetails.appTypeId,
        draftTitle: this.draftTitle,
        draftMpgId: draftMpgId,
        jobId: this.caseDetails.jobId,
        draftContentData: btoa(unescape(encodeURIComponent(this.data.value))), //this.updatedDraftBase64,
        draftHeader: btoa(unescape(encodeURIComponent(this.headerData))),
        draftFooter: btoa(unescape(encodeURIComponent(this.footerData))),
        mpgId: this.mpgId ? this.mpgId : -1,
        workflowActionId: this.dialogData?.actionId,
        docTypeCode: docTypeCode,
        //letterNo: this.letterNo,
        eventId:
          this.dialogData?.actionId?.toString() == '-1'
            ? this.dialogData?.newEventId
              ? Number(this.dialogData?.newEventId)
              : this.dialogData?.templateNotificationEventId
              ? Number(this.dialogData?.templateNotificationEventId)
              : -1
            : -1,
        letterNo: this.dialogData?.draftTitle,
        // added for onlyoffice check
        officeEnabled: this.dialogData?.officeEnabled
          ? this.dialogData?.officeEnabled
          : false,
      };
    } else if (this.from == 'view') {
      data = {
        draftId: this.selectedDraft.draftId,
        refId: this.caseDetails.docId,
        appId: this.caseDetails.appTypeId,
        draftTitle: this.draftTitle,
        draftMpgId: this.selectedDraft.draftMpgId,
        jobId: this.caseDetails.jobId,
        draftContentData: btoa(unescape(encodeURIComponent(this.data.value))), //this.updatedDraftBase64,
        draftHeader: btoa(unescape(encodeURIComponent(this.headerData))),
        draftFooter: btoa(unescape(encodeURIComponent(this.footerData))),
        mpgId: this.mpgId,
        workflowActionId: this.dialogData?.actionId,
        docTypeCode: docTypeCode,

        eventId:
          this.dialogData?.actionId?.toString() === '-1'
            ? this.dialogData?.newEventId
              ? Number(this.dialogData?.newEventId)
              : this.dialogData?.templateNotificationEventId
              ? Number(this.dialogData?.templateNotificationEventId)
              : -1
            : -1,
        docPublishType: this.dialogData?.selectedDraft?.publishMode,
        // letterNo: this.selectedDraft?.draftTitle
        //   .split('-')[1]
        //   .trim()
        //   .replace(/\D/g, ''),
      };
    }

    return data;
  }

  preview() {
    let draft_Id = -1;
    if (this.from == 'prepare') {
      draft_Id = this.draftId ? this.draftId : -1;
    } else if (this.from == 'view') {
      draft_Id = this.selectedDraft.draftId;
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let params = new HttpParams()
      .append('draftId', draft_Id)
      .append('mpgId', this.mpgId ? this.mpgId : -1)
      .append('isListFlag', false)
      .append(
        'mvmntPk',
        this.caseDetails.jobMvmntPk ? this.caseDetails.jobMvmntPk : -1
      );
    this.http
      .get('/case-mgmnt/preview-draft', {
        headers: headers,
        params: params,
      })
      .subscribe((res: any) => {
        this.showAttachmentFlag = true;
        this.previewSrc = this.sanitize.bypassSecurityTrustResourceUrl(
          'data:' + 'application/pdf' + ';base64,' + res?.data?.fileBytes
        );
        this.fileBytes = res?.data?.fileBytes;
        this.contentData = atob(res?.data?.fileBytes);
        this.headerData = atob(res?.data?.headerFileBytes);
        this.footerData = atob(res?.data?.footerFileBytes);
        this.contentTemplate = atob(res?.data?.fileBytes);
        this.headerTemplate = atob(res?.data?.headerFileBytes);
        this.footerTemplate = atob(res?.data?.footerFileBytes);
        this.mpgId = res?.data?.mpgId;
        this.docTypeCode = res?.data?.docTypeCode;
        this.setEditorPreviewHeight();
      });
  }

  getApprovedDraftView() {
    let draft_Id = -1;
    if (this.from == 'prepare') {
      draft_Id = this.draftId ? this.draftId : -1;
    } else if (this.from == 'view') {
      draft_Id = this.selectedDraft.draftId;
    }
    this.mpgId =
      this.selectedDraft.mpgId == '-1'
        ? this.dialogData.mpgId
        : this.selectedDraft.mpgId;
    let params = new HttpParams().set('mpgId', this.mpgId);
    this.http.get('/dms/file-content', { params: params }).subscribe(
      (res: any) => {
        this.draftBase64 = res.data.fileBytes;
        this.attachId = res?.data?.attachId;
        this.previewSrc = this.sanitize.bypassSecurityTrustResourceUrl(
          'data:' + 'application/pdf' + ';base64,' + this.draftBase64
        );
        this.data.setValue(atob(this.draftBase64));
        this.draftTitle = res.data.docFileName;
        this.showAttachmentFlag = true;
      },
      () => {
        //error
      }
    );
  }
  closeAttachment() {
    //ADDED CONDITION FOR PREV TO EDIT MODE
    this.openDraft(-1);
  }
  approve(): void {
    if (
      !this.appInitService?.appConfig?.configurableFields
        ?.hideApproveCnfrmtnDialogInDrafts
    ) {
      const dialogRef = this.dialog.open(ApproveDraftConfirmationComponent, {
        data: this.fileBytes,
        disableClose: true,
      });
      dialogRef.componentInstance.confirmed.subscribe((confirmed: Boolean) => {
        if (confirmed) {
          this.approveDraft();
        }
      });
    } else {
      this.approveDraft();
    }
  }
  approveDraft(): void {
    this.save('').subscribe(() => {
      let draft_Id = -1;
      if (this.from == 'prepare') {
        draft_Id = this.draftId ? this.draftId : -1;
      } else if (this.from == 'view') {
        draft_Id = this.selectedDraft.draftId;
      }
      let docTypeCode = '';
      if (this.dialogData?.docTypeCode) {
        docTypeCode = this.dialogData?.docTypeCode;
      } else if (this.dialogData?.draftTitleDesc) {
        docTypeCode = this.dialogData?.draftTitleDesc;
      } else {
        docTypeCode = null;
      }
      const input = {
        ServiceID: '2413',
        refId: this.caseDetails?.docId,
        appId: '1',
        draftId: draft_Id,
        mvmntPk: -1,
        additionalDtls: this.dialogData?.additionalDtls,
        attachId: this.attachId,
        mpgId: this.mpgId,
        docTypeCode: docTypeCode,
      };
      delete input?.additionalDtls?.data?.componentAddress;
      delete input?.additionalDtls?.data?.componentInputs;
      delete input?.additionalDtls?.data?.componentOutputIds;
      delete input?.additionalDtls?.data?.componentOutputs;

      delete input?.additionalDtls?.componentAddress;
      delete input?.additionalDtls?.componentInputs;
      delete input?.additionalDtls?.componentOutputIds;
      delete input?.additionalDtls?.componentOutputs;

      this.http.post('/case-mgmnt/approve-draft', input).subscribe(
        (res: any) => {
          this.showSaveBtn = false;
          this.showSaveAndCloseBtn = false;
          this.showApproveBtn = false;
          this.showPreviewBtn = false;
          this.showSaveAndPublishBtn = false;
          this.beforeApproveDrftMpgId = this.mpgId;
          this.isDraftApproved = true;
          this.onlyPreview = true;
          this.readOnlyCkeditor = true;
          this.from = 'view';
          this.selectedDraft.draftStatus = '970';
          this.selectedDraft.mpgId = res?.data?.mpgId;
          this.dialogData.selectedDraft = this.selectedDraft;
          //this.getDraftData();
          this.getApprovedDraftView();
        },
        (err) => {
          //
          console.log(err);
        }
      );
    });
  }
  onPublish(): void {
    let postData = this.prepareNotificationVO();
    let postData2 = this.preapareSaveDraftVO();

    postData2.notificationVO = postData;

    this.http
      .post('/case-mgmnt/publish-document', postData2)
      ?.subscribe((res) => {
        this.dialogRef.close({
          canProceed: true,
          attach: this.attachId,
          eventName: 'publish',
          event: 0,
        });
      });
  }

  prepareNotificationVO(): any {
    let postData = {
      draftVersionId: 1,
      langId: 1,
      toNotifyList: null,
      transactionId: 666,
      attachList: [
        { attachId: this.attachId, mpgIdArr: [this.selectedDraft.mpgId] },
      ],
      attachId: this.attachId,
      locId: 1,
      userId: 33,
      subjectId: this.dialogData?.case?.subjectId
        ? Number(this.dialogData?.case?.subjectId)
        : null,
      ntfDisplayNo: this.dialogData?.case?.docNo
        ? 'Draft Notification of ' + this.dialogData?.case?.docNo
        : null,
      statusId: this.dialogData?.case?.statusId
        ? Number(this.dialogData?.case?.statusId)
        : null,
      applicationId: this.dialogData?.case?.appTypeId
        ? Number(this.dialogData?.case?.appTypeId)
        : null,
      eventId: this.dialogData?.templateNotificationEventId
        ? Number(this.dialogData?.templateNotificationEventId)
        : null,
      param: this.getPlaceHolderMap(),
      placeHolderMap: this.dialogData?.plMapForLetter
        ? this.dialogData?.plMapForLetter
        : null,
      additionalDtls: this.dialogData?.additionalDtls,
      docPublished: 1,
      docTypeCode: this.dialogData?.docTypeCode
        ? this.dialogData?.docTypeCode
        : null,
      mpgId: this.dialogData?.mpgId ? this.dialogData?.mpgId : null,
    };

    postData.placeHolderMap = {
      ...postData?.placeHolderMap,
      ...this.getPlaceHolderMap(),
    };
    postData.placeHolderMap = {
      ...postData?.placeHolderMap,
      ...this.setAdditionalAttibute(),
    };

    delete postData?.additionalDtls?.cases?.[0]?.componentAddress;
    delete postData?.additionalDtls?.cases?.[0]?.componentInputs;
    delete postData?.additionalDtls?.cases?.[0]?.componentOutputIds;
    delete postData?.additionalDtls?.cases?.[0]?.componentOutputs;

    delete postData?.additionalDtls?.componentAddress;
    delete postData?.additionalDtls?.componentInputs;
    delete postData?.additionalDtls?.componentOutputIds;
    delete postData?.additionalDtls?.componentOutputs;

    return postData;
  }
  getPlaceHolderMap() {
    return this.dialogData?.paramForLetter
      ? {
          ...this.dialogData?.paramForLetter,

          CustAddDetail: {
            CustRefNo: this.dialogData?.additionalDtls?.custRefNum
              ? this.dialogData?.additionalDtls?.custRefNum
              : this.dialogData?.case?.additionalAttribute2
              ? this.dialogData?.case?.additionalAttribute2
              : null,
          },
        }
      : {
          CustAddDetail: {
            CustRefNo: this.dialogData?.additionalDtls?.custRefNum
              ? this.dialogData?.additionalDtls?.custRefNum
              : this.dialogData?.case?.additionalAttribute2
              ? this.dialogData?.case?.additionalAttribute2
              : null,
          },
        };
  }

  setAdditionalAttibute() {
    return {
      additionalAttribute1: this.dialogData?.case?.additionalAttribute1,
      additionalAttribute2: this.dialogData?.case?.additionalAttribute2,
      additionalAttribute3: this.dialogData?.case?.additionalAttribute3,
      additionalAttribute4: this.dialogData?.case?.additionalAttribute4,
      additionalAttribute5: this.dialogData?.case?.additionalAttribute5,
      fileId: this.dialogData?.case?.docId,
    };
  }

  onChange(e: CKEditor4.EventInfo): void {
    this.contentData = this.data.value;
    if (!this.isEditorLoaded) {
      return;
    }
    const currentContent = e.editor.getData();
    if (this.selectedDraft.draftStatus?.toString() === '970') {
      this.isDraftChanged = false;
    } else {
      if (currentContent === this.contentData) {
        this.isDraftChanged = false;
      } else {
        this.isDraftChanged = true;
      }
    }
  }

  getDocTypeConfigVOFromDocTypeCode(
    docTypeCode,
    actionId,
    caseId,
    eventId,
    flag
  ): Observable<any> {
    if (this.dialogData?.isFromCustomAction) {
      eventId = -1;
    } else {
      actionId = -1;
    }
    return this.http?.get(
      `/workflow/getdoctypeconfig-template?docTypeCode=${docTypeCode}&eventId=${eventId}&actionId=${actionId}&caseId=${caseId}&flag=${flag}`
    );
  }

  createVersionOfDraft(): void {
    let actionId = this.dialogData?.actionId;
    let caseId = this.caseDetails?.docId;
    let eventId = this.dialogData?.templateNotificationEventId
      ? Number(this.dialogData?.templateNotificationEventId)
      : -1;
    let draftId = this.selectedDraft.draftId;

    if (this.dialogData?.isFromCustomAction) {
      eventId = -1;
    } else {
      actionId = -1;
    }

    let dialogRef = this.dialog.open(DraftVersionConfirmationDialogComponent);

    dialogRef.afterClosed()?.subscribe((result: any) => {
      if (result > -1) {
        this.data.setValue('');
        this.http
          .get(
            `/case-mgmnt/generate-new-vrsn-drft?draftId=${draftId}&eventId=${eventId}&actionId=${actionId}&caseId=${caseId}&drftTitle=${
              this.draftMpgDtls?.optionText
            }&drftMpgId=${this.dialogData?.draftMpgDtls?.optionValue}&mpgId=${
              this.beforeApproveDrftMpgId
            }&versionFlag=${result}&docTypeCode=${
              this.dialogData?.docTypeCode ? this.dialogData?.docTypeCode : null
            }`
          )
          ?.subscribe((res) => {
            this.attachId = -1;
            this.setPreviewDraftData(res, true, result);
          });
      }
    });
  }

  setPreviewDraftData(res, flag: boolean = false, versionFlag: any = -1): void {
    if (!flag) {
      this.draftTitle = res?.data?.draftTitle;
      this.draftBase64 = res?.data?.resultVO?.remarks;
      setTimeout(() => {
        this.data.setValue(this.draftBase64);
      });
      this.contentData = this.data?.value;

      this.headerData = res?.data?.resultVO?.headerTmplt
        ? res?.data?.resultVO?.headerTmplt
        : '';
      this.footerData = res?.data?.resultVO?.footerTmplt
        ? res?.data?.resultVO?.footerTmplt
        : '';
      //this.data.setValue(this.contentData);
      this.headerTemplate = this?.headerData;
      this.contentTemplate = this?.data;
      this.footerTemplate = this?.footerData;
    } else {
      this.isDraftApproved = false;
      this.draftId = -1;
      this.mpgId = -1;
      this.attachId = -1;
      if (versionFlag === contentValue.createDraftWithCurrentContent) {
        this.draftTitle = res.data?.docFileName;
        this.contentData = atob(res?.data?.fileBytes);
        this.headerData = atob(res?.data?.headerFileBytes);
        this.footerData = atob(res?.data?.footerFileBytes);
        this.contentTemplate = atob(res?.data?.fileBytes);
        this.data.setValue(res?.data?.strContent);
        this.headerTemplate = atob(res?.data?.headerFileBytes);
        this.footerTemplate = atob(res?.data?.footerFileBytes);

        res.SUB_DRAFT_MPG_ID = this.dialogData?.draftMpgDtls?.optionValue;
        res.TEMPLATE_NAME = this.dialogData?.draftMpgDtls?.optionText;
        res.templateId = this.dialogData?.tmpltId;
        this.dialogData.selectedDraft = {};
        res.publishMode = this.dialogData?.selectedDraft?.publishMode;
        this.beforeApproveDrftMpgId = -1;
        this.draftId = -1;
        this.mpgId = -1;

        this.attachId = -1;
        this.showAttachmentFlag = false;

        this.setDocDtls(res, versionFlag);
      } else {
        this.getDraftData(versionFlag);
      }
    }
  }

  saveToClipboard(): void {
    window.localStorage.setItem('attachId', String(this.dialogData.attachId));
    this.messageDisplayService.successToast({
      messages: ['Saved to clipboard successfully'],
    });
  }

  addClip(evnt) {
    if (window.localStorage.attachId) {
      this.http
        .get(
          `/case-mgmnt/draft-dtls-by-attachId?attachId=${window.localStorage.attachId}`
        )
        .pipe(map((res: any) => res?.data))
        .subscribe((data) => {
          console.log(data);
          let attachmentSourceDataFromClipBoard = '';
          if (data?.strHeader) {
            attachmentSourceDataFromClipBoard =
              attachmentSourceDataFromClipBoard + data?.strHeader;
          }
          if (data?.strContent) {
            attachmentSourceDataFromClipBoard =
              attachmentSourceDataFromClipBoard + data?.strContent;
          }
          if (data?.strFooter) {
            attachmentSourceDataFromClipBoard =
              attachmentSourceDataFromClipBoard + data?.strFooter;
          }

          if (attachmentSourceDataFromClipBoard) {
            let contentHtml = `<style>
            .subTmplt .tmplt-header-tfl-address {
              position: static !important;
              float: right !important;
              margin-top: 65px;
              margin-right: 0px;
            }
            .subTmplt .tmplt-header-logo {
              position: static !important;
              float: right !important;
              margin-top: -65px;
              margin-left:132mm
            }
          </style>
          <div class="subTmplt">
            ${attachmentSourceDataFromClipBoard}
          </div>          
          `;
            evnt?.editor?.insertHtml(contentHtml);
          }
        });
    }
  }
}

@Component({
  selector: 'draft-version-confirmation-dialog',
  templateUrl: './draft-version-confirmation-dialog.component.html',
  styleUrls: ['./draft-version-confirmation-dialog.component.scss'],
})
export class DraftVersionConfirmationDialogComponent implements OnInit {
  selectedOption;

  constructor(
    private dialogRef: MatDialogRef<DraftVersionConfirmationDialogComponent>
  ) {}

  ngOnInit(): void {}

  confrim(): void {
    this.dialogRef.close(
      this.selectedOption?.toString() === '0'
        ? contentValue.createDraftWithCurrentContent
        : contentValue.createDraftWithOriginalTemplate
    );
  }

  cancel(): void {
    this.dialogRef.close(-1);
  }
}

export enum contentValue {
  createDraftWithOriginalTemplate = 1,
  createDraftWithCurrentContent = 0,
}
